"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FullPageError = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Modal_1 = __importDefault(require("@material-ui/core/Modal"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const react_router_1 = require("react-router");
const useStyles = styles_1.makeStyles((theme) => styles_1.createStyles({
    paper: {
        position: 'absolute',
        width: '100vw',
        height: '100vh',
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
        top: 0,
        left: 0,
    },
    button: {
        margin: theme.spacing(1),
    },
}));
function FullPageError({ error, routeTo = '/' }) {
    const classes = useStyles();
    const history = react_router_1.useHistory();
    const [open, setOpen] = react_1.default.useState(true);
    const handleClose = () => {
        setOpen(false);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(Modal_1.default, { open: open, onClose: handleClose, "aria-labelledby": "simple-modal-title", "aria-describedby": "simple-modal-description" },
            react_1.default.createElement(Paper_1.default, { className: classes.paper },
                react_1.default.createElement(Typography_1.default, { variant: "h2", id: "simple-modal-title" }, "Something went wrong!"),
                react_1.default.createElement(Typography_1.default, { id: "simple-modal-description" }, "The following error has been detected:"),
                react_1.default.createElement(Typography_1.default, { component: "pre", color: "error" }, error.message),
                react_1.default.createElement("br", null),
                react_1.default.createElement(Button_1.default, { className: classes.button, size: "small", variant: "outlined", onClick: () => {
                        if (history.location.pathname === routeTo) {
                            setOpen(false);
                        }
                        else {
                            history.push(routeTo);
                        }
                    } }, "Take me home")))));
}
exports.FullPageError = FullPageError;
